import {
  DisplayMode,
  MarketingDetailCategoryInterface,
  MarketingDetailGroupInterface,
  MarketingDetailItemInterface,
  MarketingDetailsApiResponseInterface,
  SectionType,
  MarketingDetailColumnItemInterface,
  MarketingDetailColumnGroupInterface
} from '../../models/marketing-detail.model';
import {FOOTER_GROUP_NAME} from '../../constants/marketing-detail.constants';

function isNewShape(data: unknown): boolean {
  return typeof data === 'object' && data !== null && !Array.isArray(data);
}

function transformBenefitDetailsItem(legacy: MarketingDetailColumnItemInterface): MarketingDetailItemInterface {
  return {
    description: legacy.column1 || '',
    quantity: legacy.column2 || null,
    youPay: null,
    youSave: legacy.column3 || null,
    hasException: false,
    exceptionText: null,
    asteriskNotation: null,
    memberPays: null,
    adaCode: null,
    sectionType: SectionType.BENEFIT_DETAILS
  };
}

function transformCDPSItem(legacy: MarketingDetailColumnItemInterface): MarketingDetailItemInterface {
  return {
    description: legacy.column2 || '',
    quantity: null,
    youPay: null,
    youSave: null,
    hasException: false,
    exceptionText: null,
    asteriskNotation: null,
    memberPays: legacy.column3 || null,
    adaCode: legacy.column1 || null,
    sectionType: SectionType.COMMON_DENTAL_PLAN_SAVINGS
  };
}

function transformFooterItem(legacy: MarketingDetailColumnItemInterface, sectionType: SectionType): MarketingDetailItemInterface {
  return {
    description: legacy.column1 || '',
    quantity: null,
    youPay: null,
    youSave: null,
    hasException: false,
    exceptionText: null,
    asteriskNotation: null,
    memberPays: null,
    adaCode: null,
    sectionType: sectionType
  };
}

function transformLegacyGroups(
  legacyGroups: MarketingDetailColumnGroupInterface[],
  sectionType: SectionType,
  transformItem: (legacy: MarketingDetailColumnItemInterface) => MarketingDetailItemInterface
): MarketingDetailCategoryInterface {
  const groups: MarketingDetailGroupInterface[] = (legacyGroups || []).map(legacyGroup => ({
    itemName: legacyGroup.itemName,
    items: (legacyGroup.value || []).map(item =>
      legacyGroup.itemName === FOOTER_GROUP_NAME ? transformFooterItem(item, sectionType) : transformItem(item)
    )
  }));

  return {
    displayMode: DisplayMode.SAVINGS_ONLY,
    exceptions: [],
    groups: groups,
    xrayExamFooterText: null
  };
}

export function transformMarketingDetails(response: MarketingDetailsApiResponseInterface): MarketingDetailsApiResponseInterface {
  if (!response?.salesPlanMarketingDetails) return response;

  const marketingDetails = response.salesPlanMarketingDetails;

  if (marketingDetails.planBenefits && !isNewShape(marketingDetails.planBenefits)) {
    marketingDetails.planBenefits = transformLegacyGroups(
      marketingDetails.planBenefits as unknown as MarketingDetailColumnGroupInterface[],
      SectionType.BENEFIT_DETAILS,
      transformBenefitDetailsItem
    );
  }

  if (marketingDetails.commonDentalPlanSavings && !isNewShape(marketingDetails.commonDentalPlanSavings)) {
    marketingDetails.commonDentalPlanSavings = transformLegacyGroups(
      marketingDetails.commonDentalPlanSavings as unknown as MarketingDetailColumnGroupInterface[],
      SectionType.COMMON_DENTAL_PLAN_SAVINGS,
      transformCDPSItem
    );
  }

  return response;
}
